import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			style: { InkscapeStroke: "none" },
			d: "M15.92 15a1 1 0 00-1 1 1 1 0 001 1h13a1 1 0 001-1 1 1 0 00-1-1z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M23.93 25v3h-16V4h16v3h2V3a1 1 0 00-1-1h-18a1 1 0 00-1 1v26a1 1 0 001 1h18a1 1 0 001-1v-4z" }),
		/* @__PURE__ */ _jsx("path", {
			style: { InkscapeStroke: "none" },
			d: "M24.92 5.09a1 1 0 00-1 1v2a1 1 0 001 1 1 1 0 001-1v-2a1 1 0 00-1-1zm-.707 6.203a1 1 0 000 1.414L27.506 16l-3.293 3.293a1 1 0 000 1.414 1 1 0 001.414 0l4-4a1 1 0 00.217-1.09 1 1 0 00-.217-.324l-4-4a1 1 0 00-1.414 0zM24.92 23a1 1 0 00-1 1v2a1 1 0 001 1 1 1 0 001-1v-2a1 1 0 00-1-1z"
		})
	]
});
export default SvgLogout;
